import React from "react";
import { Component } from "react";
import * as apiUtil from "../../../util/apiUtil";


/**
 * 250513 네이버 DA 이벤트 페이지
 * */
const DEFAULT_IMAGES = [
    "/assets/img/promotion/naver_da_event_v.1.1.png",
    "/assets/img/promotion/naver_da_event_v.2.0.jpg",
];

class EventNaverContainer extends Component {
    constructor(props) {
        super(props);

        this.ajaxCountAdSrc = this.ajaxCountAdSrc.bind(this);

        this.state = {};
    }

    componentDidMount() {
        if (!window.sessionStorage.getItem('sessionId')) {
            window.sessionStorage.setItem('sessionId', crypto.randomUUID());
        }
        this.ajaxCountAdSrc();
    }

    async ajaxCountAdSrc() {
        const adSrc = sessionStorage.getItem('adSrc');
        const sessionId = sessionStorage.getItem('sessionId');

        apiUtil.asyncRequest({
            url: `/api/common/adpath/count`,
            method: apiUtil.requestMethod.POST,
            data: {
                adSrc,
                type: 'VISIT',
                sessionId,
            },
            success: (result) => { }
        });
    }

    render() {
        const { campaignId } = this.props;

        const imgSrc = campaignId === 'naver_da_001' ? DEFAULT_IMAGES[0] : DEFAULT_IMAGES[1];

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: '100vh', margin: '0', fontFamily: 'Arial, sans-serif', backgroundColor: '#ffffff' }}>
                <div style={{ textAlign: 'center', width: '100%', maxWidth: '500px', marginTop: '50px' }}>
                    <img src={imgSrc} alt="네이버 DA 프로모션 이미지" style={{ width: '100%', maxWidth: '400px', margin: '15px auto', display: 'block' }} />
                    <button
                        style={{
                            display: 'block',
                            width: '250px',
                            padding: '12px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: 'white',
                            background: '#3D3FC9',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            margin: '15px auto',
                            textAlign: 'center'
                        }}
                        onClick={() => { window.location.href = '/register/agree'; }}
                        onMouseOver={(e) => e.target.style.background = '#2A2DAF'}
                        onMouseOut={(e) => e.target.style.background = '#3D3FC9'}
                    >
                        회원가입 바로가기
                    </button>
                </div>
            </div>
        )
    }
}

export default EventNaverContainer;
